<!-- Copyright (C) 2020 Skylark Drones -->
<template>
  <v-snackbar
    bottom
    rounded="pill"
    :color="snackBarColor"
    :timeout="notificationPayload.timeout"
    v-model="showSnackBar"
  >
    {{ notificationPayload.message }}
    <template
      v-if="
        notificationPayload.timeout > 5000 || notificationPayload.timeout === -1
      "
      v-slot:action="{ attrs }"
    >
      <v-btn
        small
        rounded
        outlined
        class="ml-2"
        v-bind="attrs"
        @click="showSnackBar = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Snackbar',
  data: function () {
    return {
      showSnackBar: false
    }
  },
  computed: {
    ...mapGetters(['notificationPayload']),
    snackBarColor() {
      const code = this.notificationPayload.code
      if (code === -1) {
        return 'info'
      } else if (code < 300) {
        return 'success'
      } else {
        return 'error'
      }
    }
  },
  watch: {
    notificationPayload: function () {
      this.showSnackBar = Boolean(this.notificationPayload.message)
    }
  }
}
</script>
